module.exports = __webpack_public_path__ + "static/rendering1_mini-f1ae060cbd8c70682b6f282309e50e8d.png";